export const demoDashboardRoutes = {
    clips: () => '/demo-campaign-clips',
    creators: () => '/demo-campaign-creators',
    campaign: () => '/demo-campaign-dashboard',
};
